<template>
  <div class="container mx-auto sm:p-3 md:p-10 lg:p-20 text-center w-2/3 overflow-hidden">
    <h1 class="sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 text-gray-800 underline">Services</h1>

    <div class="container mx-auto flex flex-wrap my-8 justify-center">
      <div class="grid sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        <div v-for="item in services" :key="item.service"
          class="max-w-xl rounded overflow-hidden shadow-xl rounded  bg-white"
        >
          <div class="sm:p-4 md:p-5 lg:p-6">
            <h1 class="font-bold text-lg text-orange-500 m-2">{{item.service}}</h1>
            <hr />
            <p
              class="text-base text-gray-600 p-4"
            >{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "Services",
  data() {
    return {
      services: [
        { service: "Custom solutions", description: "Need a complete solution, from design to full production system." },
        { service: "Consulting, Strategy", description: "Need a little help figuring out what the best move is going to be." },
        { service: "Product Enginering", "description": "Research, design and creation of products"},
        { service: "Web development", description: "Need someone to build that custom website or web app that you've always dreamed about?" },
        { service: "Software development", description: "Looking for custom made software?" },
        { service: "UI + UX", description: "Need to make something easier or better looking?" }
      ]
    };
  }
};
</script>